import CustomerSearchValue from "../../../domain/customer/criteria/CustomerSearchValue";
import CustomerSortType    from "../../../domain/customer/criteria/CustomerSortType";
import Customer            from "../../../domain/customer/Customer";
import CustomerBirthDate   from "../../../domain/customer/CustomerBirthDate";
import CustomerBirthMonth  from "../../../domain/customer/CustomerBirthMonth";
import CustomerBirthYear   from "../../../domain/customer/CustomerBirthYear";
import CustomerId          from "../../../domain/customer/CustomerId";
import CustomerNumber      from "../../../domain/customer/CustomerNumber";
import CustomerRepository  from "../../../domain/customer/CustomerRepository";
import Customers           from "../../../domain/customer/Customers";
import Building            from "../../../domain/fundamentals/address/Building";
import City                from "../../../domain/fundamentals/address/City";
import PostalCode          from "../../../domain/fundamentals/address/PostalCode";
import Prefecture          from "../../../domain/fundamentals/address/Prefecture";
import Street              from "../../../domain/fundamentals/address/Street";
import Email               from "../../../domain/fundamentals/email/Email";
import GenderType          from "../../../domain/fundamentals/gender/GenderType";
import FirstName           from "../../../domain/fundamentals/name/FirstName";
import FirstNameKana       from "../../../domain/fundamentals/name/FirstNameKana";
import LastName            from "../../../domain/fundamentals/name/LastName";
import LastNameKana        from "../../../domain/fundamentals/name/LastNameKana";
import CurrentPage         from "../../../domain/fundamentals/pagination/CurrentPage";
import Phone               from "../../../domain/fundamentals/phone/Phone";
import { ApiClient }       from "../../configure/ApiClientConfig";
import {
  setCustomerAction,
  setCustomerContactBuildingAction,
  setCustomerContactCityAction,
  setCustomerContactEmailAction,
  setCustomerContactPhoneAction,
  setCustomerContactPostalCodeAction,
  setCustomerContactPrefectureAction,
  setCustomerContactStreetAction,
  setCustomerDetailBirthdayDateAction,
  setCustomerDetailBirthdayMonthAction,
  setCustomerDetailBirthdayYearAction,
  setCustomerDetailFirstNameAction,
  setCustomerDetailFirstNameKanaAction,
  setCustomerDetailGenderTypeAction,
  setCustomerDetailLastNameAction,
  setCustomerDetailLastNameKanaAction,
  setCustomerDetailNumberAction
}                          from "../../redux/customer/CustomerAction";
import {
  setCustomersAction,
  setCustomersCurrentPageAction,
  setCustomersSearchValueAction,
  setCustomersSortTypeAction
}                          from "../../redux/customer/CustomersAction";

class CustomerDataSource implements CustomerRepository {
  readonly dispatch;

  constructor(dispatch) {
    this.dispatch = dispatch;
  }

  findByCsv(search: CustomerSearchValue, sortType: CustomerSortType) {
    return ApiClient.get("/customers/export", {
      params: {
        search: search.value,
        sortType: sortType,
      }
    });
  }

  findByPage(current: CurrentPage, search: CustomerSearchValue, sortType: CustomerSortType) {
    return ApiClient.get("/customers", {
      params: {
        page: current.value,
        search: search.value,
        sortType: sortType,
      }
    });
  }

  findByHaveEmailPage(current: CurrentPage, search: CustomerSearchValue) {
    return ApiClient.get("/customers/email", {
      params: {
        page: current.value,
        search: search.value,
      }
    })
  }

  findAllHaveEmail(search: CustomerSearchValue) {
    return ApiClient.get("/customers/email/all", {
      params: {
        search: search.value,
      }
    })
  }

  findBy(customerId: CustomerId) {
    return ApiClient.get("/customer", {
      params: {
        customerId: customerId.value,
      }
    });
  }

  delete(customerId: CustomerId) {
    return ApiClient.delete("/customer", {
      params: {
        customerId: customerId.value,
      }
    });
  }

  register(customer: Customer) {
    return ApiClient.post("/customer", {
      detail: {
        number: customer.detail.number.value,
        last_name: customer.detail.name.lastName.value,
        first_name: customer.detail.name.firstName.value,
        last_name_kana: customer.detail.name.lastNameKana.value,
        first_name_kana: customer.detail.name.firstNameKana.value,
        gender_type: customer.detail.genderType,
      },
      birthday: {
        year: customer.birthday.year.value,
        month: customer.birthday.month.value,
        date: customer.birthday.date.value,
      },
      contact: {
        phone_number: customer.contact.phone.value,
        email: customer.contact.email.value,
      },
      address: {
        postal_code: customer.address.postalCode.value,
        prefecture: customer.address.prefecture.value,
        city: customer.address.city.value,
        street: customer.address.street.value,
        building: customer.address.building.value,
      }
    });
  }

  update(customer: Customer) {
    return ApiClient.put("/customer", {
      id: customer.id.value,
      detail: {
        number: customer.detail.number.value,
        last_name: customer.detail.name.lastName.value,
        first_name: customer.detail.name.firstName.value,
        last_name_kana: customer.detail.name.lastNameKana.value,
        first_name_kana: customer.detail.name.firstNameKana.value,
        gender_type: customer.detail.genderType,
      },
      birthday: {
        year: customer.birthday.year.value,
        month: customer.birthday.month.value,
        date: customer.birthday.date.value,
      },
      contact: {
        phone_number: customer.contact.phone.value,
        email: customer.contact.email.value,
      },
      address: {
        postal_code: customer.address.postalCode.value,
        prefecture: customer.address.prefecture.value,
        city: customer.address.city.value,
        street: customer.address.street.value,
        building: customer.address.building.value,
      }
    });
  }

  import(csvData: {}) {
    return ApiClient.post("/customer/csv/import", {
      csvData: csvData
    });
  }

  setCurrentPage(currentPage: CurrentPage) {
    this.dispatch(setCustomersCurrentPageAction(currentPage));
  }

  setCustomers(customers: Customers) {
    this.dispatch(setCustomersAction(customers));
  }

  setSearchValue(search: CustomerSearchValue) {
    this.dispatch(setCustomersSearchValueAction(search));
  }

  setSortType(sortType: CustomerSortType) {
    this.dispatch(setCustomersSortTypeAction(sortType));
  }

  setCustomer(customer: Customer) {
    this.dispatch(setCustomerAction(customer));
  }

  setCustomerNumber(customerNumber: CustomerNumber) {
    this.dispatch(setCustomerDetailNumberAction(customerNumber));
  }

  setCustomerLastName(lastName: LastName) {
    this.dispatch(setCustomerDetailLastNameAction(lastName));
  }

  setCustomerFirstName(firstName: FirstName) {
    this.dispatch(setCustomerDetailFirstNameAction(firstName));
  }

  setCustomerLastNameKana(lastNameKana: LastNameKana) {
    this.dispatch(setCustomerDetailLastNameKanaAction(lastNameKana));
  }

  setCustomerFirstNameKana(firstNameKana: FirstNameKana) {
    this.dispatch(setCustomerDetailFirstNameKanaAction(firstNameKana));
  }

  setCustomerGenderType(genderType: GenderType) {
    this.dispatch(setCustomerDetailGenderTypeAction(genderType));
  }

  setCustomerBirthdayYear(year: CustomerBirthYear) {
    this.dispatch(setCustomerDetailBirthdayYearAction(year));
  }

  setCustomerBirthdayMonth(month: CustomerBirthMonth) {
    this.dispatch(setCustomerDetailBirthdayMonthAction(month));
  }

  setCustomerBirthdayDate(date: CustomerBirthDate) {
    this.dispatch(setCustomerDetailBirthdayDateAction(date));
  }

  setCustomerPhone(phone: Phone) {
    this.dispatch(setCustomerContactPhoneAction(phone));
  }

  setCustomerEmail(email: Email) {
    this.dispatch(setCustomerContactEmailAction(email));
  }

  setCustomerPostalCode(postalCode: PostalCode) {
    this.dispatch(setCustomerContactPostalCodeAction(postalCode));
  }

  setCustomerPrefecture(prefecture: Prefecture) {
    this.dispatch(setCustomerContactPrefectureAction(prefecture));
  }

  setCustomerCity(city: City) {
    this.dispatch(setCustomerContactCityAction(city));
  }

  setCustomerStreet(street: Street) {
    this.dispatch(setCustomerContactStreetAction(street));
  }

  setCustomerBuilding(building: Building) {
    this.dispatch(setCustomerContactBuildingAction(building));
  }
}

export default CustomerDataSource;
